import React from 'react';

const paths = {
  menu: <path d="M4 6h16M4 12h16M4 18h16"/>,
  user: <><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></>,
  piano: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M7 5v8h3V5m4 0v8h3V5M9 13v6m6-6v6"/></>,
  notes: <><path d="M5 3h10l4 4v14H5zM14 3v5h5M8 12h8M8 16h6"/></>,
  zoom: <><circle cx="10" cy="10" r="6"/><path d="m15 15 6 6M7 10h6M10 7v6"/></>,
  grid: <><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M3 15h18M9 4v16M15 4v16"/></>,
  save: <><path d="M5 3h12l4 4v14H3V3z"/><path d="M7 3v6h10V3M7 21v-8h10v8"/></>,
  pointer: <path d="m5 3 14 9-7 1-3 7z"/>,
  trim: <><path d="M7 4v16M17 4v16M7 12h10M3 8l4 4-4 4M21 8l-4 4 4 4"/></>,
  select: <rect x="4" y="4" width="16" height="16" rx="2" strokeDasharray="3 3"/>,
  grab: <><path d="M8 12V7a2 2 0 0 1 4 0v5-7a2 2 0 0 1 4 0v7-4a2 2 0 0 1 4 0v7c0 4-3 7-7 7h-1c-2 0-3-1-4-3l-4-6a2 2 0 0 1 3-2l1 1"/></>,
  pencil: <><path d="m14 4 6 6M4 20l5-1L21 7a2 2 0 0 0-4-4L5 15z"/></>,
  scrub: <><path d="M12 3v18M3 9l4 3-4 3M21 9l-4 3 4 3"/></>,
  split: <><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="m8.5 7.5 12 12m-12-3 12-12"/></>,
  heal: <><path d="M3 6v12h6M21 6v12h-6M9 12h6M12 9v6"/></>,
  follow: <><path d="M4 5v14M20 5v14M7 12h10m-3-3 3 3-3 3"/></>,
  home: <><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10.5V20h13v-9.5"/><path d="M9.5 20v-6h5v6"/></>,
  folder: <path d="M3 6.5h7l2 2h9v10.5H3z"/>,
  users: <><circle cx="9" cy="8" r="3"/><path d="M3 20c.4-4 2.4-6 6-6s5.6 2 6 6"/><path d="M16 5.5a3 3 0 0 1 0 5.5M16.5 14c2.7.4 4.1 2.4 4.5 5"/></>,
  wave: <path d="M3 12h2l1.5-5 3 10 3-13 3 16 2.5-8H21"/>,
  bag: <><path d="M4 8h16l-1 12H5z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></>,
  library: <><rect x="3" y="4" width="7" height="7" rx="1.5"/><rect x="14" y="4" width="7" height="7" rx="1.5"/><rect x="3" y="15" width="7" height="6" rx="1.5"/><rect x="14" y="15" width="7" height="6" rx="1.5"/></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></>,
  play: <path d="m9 6 9 6-9 6z" fill="currentColor" stroke="none"/>,
  pause: <><path d="M8 6v12M16 6v12"/></>,
  stop: <rect x="8" y="8" width="8" height="8" rx="1" fill="currentColor" stroke="none"/>,
  restart: <><path d="M5 8V3L2 6"/><path d="M5 5.5a8 8 0 1 1-1 10"/></>,
  record: <circle cx="12" cy="12" r="5" fill="currentColor" stroke="none"/>,
  undo: <><path d="m8 7-5 5 5 5"/><path d="M4 12h9a7 7 0 0 1 7 7"/></>,
  redo: <><path d="m16 7 5 5-5 5"/><path d="M20 12h-9a7 7 0 0 0-7 7"/></>,
  share: <><path d="M12 16V3"/><path d="m7 8 5-5 5 5"/><path d="M5 12v8h14v-8"/></>,
  sparkle: <><path d="M12 2c.7 5.3 2.7 7.3 8 8-5.3.7-7.3 2.7-8 8-.7-5.3-2.7-7.3-8-8 5.3-.7 7.3-2.7 8-8Z"/><path d="M19 16c.2 1.8.9 2.5 3 3-2.1.4-2.8 1.1-3 3-.3-1.9-1-2.6-3-3 2-.5 2.7-1.2 3-3Z"/></>,
  sliders: <><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></>,
  chevron: <path d="m9 6 6 6-6 6"/>,
  more: <><circle cx="5" cy="12" r="1" fill="currentColor"/><circle cx="12" cy="12" r="1" fill="currentColor"/><circle cx="19" cy="12" r="1" fill="currentColor"/></>,
  plus: <path d="M12 5v14M5 12h14"/>,
  close: <path d="m6 6 12 12M18 6 6 18"/>,
  metronome: <><path d="M8 20h8l-2-16h-4z"/><path d="m12 12 5-4"/></>,
  mic: <><rect x="9" y="3" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></>
};

export default function StudioIcon({ name, size = 18, strokeWidth = 1.7, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      {paths[name] || paths.sparkle}
    </svg>
  );
}

